import { FC, useRef } from "react";
import Portail from "../components/AquaHydra/Portail";
import InteractiveCarte from "../components/Carte/InteractiveCarte";
import ContactForm from "../components/Contact/ContactForm";
import HomeSection from "../components/Header/HomeSection";
import Team from "../components/Team/Team";
import Video from "../components/Video/Video";
import Header from "../components/Header/Header";

interface HomeProps {}

const Home: FC<HomeProps> = () => {
  const contactFormRef = useRef<HTMLDivElement>(null);
  const aboutUsFormRef = useRef<HTMLDivElement>(null);
  const scrollToContact = () => {
    if (contactFormRef.current) {
      contactFormRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToAboutUs = () => {
    if (aboutUsFormRef.current) {
      aboutUsFormRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div>
      <Header
        onScrollToContact={scrollToContact}
        onScrollToAboutUs={scrollToAboutUs}
      />
      <HomeSection />
      <Portail />
      <div ref={aboutUsFormRef}>
        <Video
          title="Quels rôles Aquavesc et Hydreaulys jouent-ils dans la gestion des eaux ?"
          videoUrl="https://www.youtube.com/watch?v=yp9F5W9jVHA"
        />
      </div>
      <Video
        title="De quoi se compose votre facture d'eau"
        videoUrl="https://www.youtube.com/watch?v=o8zBbY2cQuQ"
      />
      <InteractiveCarte />
      <Team />
      <div ref={contactFormRef}>
        <ContactForm />
      </div>
    </div>
  );
};

export default Home;
